interface IDynamicCompanyName {
    addressTypeSelect: HTMLSelectElement;
    companyNameElement: HTMLElement;
    companyNameInput: HTMLInputElement;
    comparableAddressTypes: string[];
    onAddressTypeChange(): void;
    companyHidden: boolean;
}

export class DynamicCompanyName implements IDynamicCompanyName {
    addressTypeSelect: HTMLSelectElement;
    companyNameElement: HTMLElement;
    companyNameInput: HTMLInputElement;
    comparableAddressTypes: string[];
    companyHidden: boolean;

    constructor() {
        let addressTypeElement = document.querySelector(".form-address-type");
        if (addressTypeElement) {
            this.addressTypeSelect = addressTypeElement.querySelector('select') as HTMLSelectElement;
        }

        this.companyNameInput = document.querySelector(".dynamic-company-name") as HTMLInputElement;
        if (this.companyNameInput) {
            this.companyNameElement = this.companyNameInput.closest('.form-element') as HTMLElement;
        }

        let bootstrap = (window as any).bootstrap;
        if (bootstrap) {
            this.comparableAddressTypes = bootstrap.comparableAddressTypes;
        }

        if (this.addressTypeSelect && this.companyNameElement && this.comparableAddressTypes) {
            this.onLoad();
            this.addressTypeSelect.onchange = this.onAddressTypeChange;
        }
    }

    onLoad = () => {
        let selectedType = this.addressTypeSelect.value;

        if (this.containsType(selectedType)) {
            this.hideCompanyName();
        }      
    }

    onAddressTypeChange = () => {
        let selectedType = this.addressTypeSelect.value;

        if (!this.companyHidden && this.containsType(selectedType)) {
            this.hideCompanyName();

        }
        else if (this.companyHidden && !this.containsType(selectedType)) {
            this.showCompanyName();
        }
    }

    containsType = (value: string): boolean => {
        return this.comparableAddressTypes.some(x => x === value);
    }

    hideCompanyName = () => {
        this.companyNameElement.classList.add('removed');
        this.companyHidden = true;
        this.companyNameInput.value = null;
       
    }

    showCompanyName = () => {
        this.companyNameElement.classList.remove('removed');
        this.companyHidden = false;
    }
  
}




